// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__CyUGF","title":"ClientCherryInfo_title__2S8DS","itemText":"ClientCherryInfo_itemText__2qiTr"};